import {
  Banner,
  Container,
  Header,
  Layout,
  MainContent,
  Section,
} from '@inmotionnow/momentum-components-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { BulkImportRunPanel } from './bulk-import-run-panel'

/** One import's page: the run panel inside GIM's page chrome. */
const BulkImportRunView = () => {
  const { t } = useTranslation()
  const { runId } = useParams<{ accountId: string; runId: string }>()

  const parsedRunId = React.useMemo(() => {
    if (!runId || !/^\d+$/.test(runId)) return undefined
    const parsed = parseInt(runId, 10)
    return parsed > 0 ? parsed : undefined
  }, [runId])

  return (
    <Layout>
      <Header>
        <Banner title={t('BULK_IMPORT_RUN')} />
      </Header>
      <MainContent>
        <Section>
          <Container size='lg'>
            <BulkImportRunPanel runId={parsedRunId} />
          </Container>
        </Section>
      </MainContent>
    </Layout>
  )
}

export { BulkImportRunView }
